import React from "react";
import { RedactedPaymentPref } from "../../common/types";
import { getPaymentMethod } from "../../common/utils";
import { ExistingPaymentPrefDisplay } from "../ExistingPaymentPrefDisplay";
import { PaymentPrefActions } from "../PaymentPrefActions";
import { PaymentPrefDisplayCardContainer } from "../PaymentPrefDisplayCardContainer";
import { getPaymentMethodIconType } from "../PaymentPrefDisplayCardContainer/utils";

export type ExistingPaymentPrefDisplayCardProps = {
  paymentPref: RedactedPaymentPref;
  displayPositions?: boolean;
  displayRevealDetails?: boolean;
  displayInvalidInstructionsWarning?: boolean;
  callBacks?: {
    switchPaymentMethodCallback: () => void;
    editPaymentInstructionsCallback: () => void;
    deletePaymentInstructionsCallback: () => void;
  };
};

export const ExistingPaymentPrefDisplayCard: React.FC<ExistingPaymentPrefDisplayCardProps> = ({
  paymentPref,
  displayPositions,
  displayRevealDetails,
  callBacks,
  displayInvalidInstructionsWarning,
}: ExistingPaymentPrefDisplayCardProps) => {
  const actionComponent = callBacks && (
    <PaymentPrefActions
      paymentMethod={getPaymentMethod(paymentPref)}
      switchPaymentMethodCallback={callBacks?.switchPaymentMethodCallback}
      editPaymentInstructionsCallback={callBacks?.editPaymentInstructionsCallback}
      deletePaymentInstructionsCallback={callBacks?.deletePaymentInstructionsCallback}
    />
  );

  const iconType = getPaymentMethodIconType(paymentPref);

  return (
    <PaymentPrefDisplayCardContainer iconType={iconType} actionComponent={actionComponent}>
      <ExistingPaymentPrefDisplay
        displayPositions={displayPositions}
        displayRevealDetails={displayRevealDetails}
        paymentPref={paymentPref}
        displayInvalidInstructionsWarning={displayInvalidInstructionsWarning}
      />
    </PaymentPrefDisplayCardContainer>
  );
};
